<template>
  <div>
    <span v-if="sbi.isGroup">
      <el-menu-item-group v-bind:title="sbi.label" v-bind:index="sbi.label">
        <span v-if="sbi.children && sbi.children.length">
          <span v-for="menu in sbi.children">
            <sidebaritem v-bind:sbi="menu"></sidebaritem>
          </span>
        </span>
      </el-menu-item-group>
    </span>
    <span v-else-if="sbi.children && sbi.children.length">
      <el-submenu v-bind:index="sbi.path">
        <template slot="title"><i v-bind:class="this.getMenuClass(sbi.type)"></i>{{sbi.label}}</template>
        <span v-for="menu in sbi.children">
          <sidebaritem v-bind:sbi="menu"></sidebaritem>
        </span>
      </el-submenu>
    </span>
    <span v-else>
      <span v-if="sbi.type">
        <el-menu-item v-bind:index="sbi.path"><i v-bind:class="this.getMenuClass(sbi.type)"></i>{{sbi.label}}</el-menu-item>
      </span>
      <span v-else>
        <el-menu-item v-bind:index="sbi.path">{{sbi.label}}</el-menu-item>
      </span>
    </span>
  </div>
</template>

<script>
  import menutypesmixin from '../../api/types/menu.js'

  export default {
    name: 'sidebaritem',
    props: ['sbi'],
    mixins: [menutypesmixin],
    data() {
      return {

      }
    }
  }
</script>

<style scoped>
  .el-menu-item i {
    margin-top: -5px;
  }

</style>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layout/sidebaritem.vue